import { useHoliday, useOwnedPacks } from "@/components/holiday/useHoliday";
import { useI18n } from "@/context/I18nContext";

export const usePackAccess = (cats = []) => {
  const { lang } = useI18n();
  const { packs, themes = [] } = useHoliday();
  const [owned] = useOwnedPacks();
  const avail = packs.map((p) => p.id);
  const visible = (cats || []).filter((k) => owned.includes(k) || avail.includes(k));
  const locked = (k) => Boolean(k) && !owned.includes(k);
  const names = Object.fromEntries(themes.map((p) => [p.id, lang === "fr" ? p.fr : p.en]));
  const catLabel = (k) => (visible.includes(k) ? names[k] || k : null);
  return { visible, locked, catLabel };
};
